<div class="recorder_modal">
  <p class="recorder_modal_title">Get in touch</p>

  <p class="recorder_modal_subtitle">
    Email us to book your 60-minute stakeholder workshop.
  </p>

  <div class="cr-address">
    <span class="cr-address_value">{{ data.email }}</span>
    <button
      type="button"
      class="cr-address_copy"
      matTooltip="Copy address"
      (click)="copyEmail()"
    >
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>

  <p class="cr-label">Open a draft in</p>

  <div class="cr-options">
    <a class="cr-option" [href]="gmailHref" target="_blank" rel="noopener">
      <span class="cr-option_chip">
        <img
          class="cr-option_logo"
          src="../../../assets/img/icons/gmail-logo.svg"
          alt=""
        />
      </span>
      Gmail
    </a>
    <a class="cr-option" [href]="outlookHref" target="_blank" rel="noopener">
      <span class="cr-option_chip">
        <img
          class="cr-option_logo"
          src="../../../assets/img/icons/outlook-logo.svg"
          alt=""
        />
      </span>
      Outlook
    </a>
    <a class="cr-option" [href]="mailtoHref">
      <span class="cr-option_chip">
        <mat-icon class="cr-option_glyph">mail</mat-icon>
      </span>
      My email app
    </a>
  </div>

  <p class="cr-hint">
    “My email app” needs a mail program set up on this device. If nothing
    happens when you use it, open a webmail draft instead or copy the address.
  </p>

  <div class="button_container" style="margin-top: 24px">
    <button mat-raised-button class="seo_cancel" (click)="dialogRef.close()">
      Close
    </button>
  </div>
</div>
